"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.customWeekPicker = exports.isBetween = void 0;
var React = __importStar(require("react"));
var styles_1 = require("@mui/material/styles");
var PickersDay_1 = require("@mui/x-date-pickers/PickersDay");
var date_fns_1 = require("date-fns");
function isBetween(date, from, to, inclusivity) {
    if (inclusivity === void 0) { inclusivity = '[]'; }
    if (!['()', '[]', '(]', '[)'].includes(inclusivity)) {
        throw new Error('Inclusivity parameter must be one of (), [], (], [)');
    }
    var isBeforeEqual = inclusivity[0] === '[', isAfterEqual = inclusivity[1] === ']';
    return ((isBeforeEqual ? (0, date_fns_1.isEqual)(from, date) || (0, date_fns_1.isBefore)(from, date) : (0, date_fns_1.isBefore)(from, date)) &&
        (isAfterEqual ? (0, date_fns_1.isEqual)(to, date) || (0, date_fns_1.isAfter)(to, date) : (0, date_fns_1.isAfter)(to, date)));
}
exports.isBetween = isBetween;
var CustomPickersDay = (0, styles_1.styled)(PickersDay_1.PickersDay, {
    shouldForwardProp: function (prop) {
        return prop !== 'dayIsBetween' && prop !== 'isFirstDay' && prop !== 'isLastDay';
    },
})(function (_a) {
    var theme = _a.theme, dayIsBetween = _a.dayIsBetween, isFirstDay = _a.isFirstDay, isLastDay = _a.isLastDay;
    return (__assign(__assign(__assign({}, (dayIsBetween && {
        borderRadius: 0,
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        '&:hover, &:focus': {
            backgroundColor: theme.palette.primary.dark,
        },
    })), (isFirstDay && {
        borderTopLeftRadius: '50%',
        borderBottomLeftRadius: '50%',
    })), (isLastDay && {
        borderTopRightRadius: '50%',
        borderBottomRightRadius: '50%',
    })));
});
var customWeekPicker = function (value) {
    return function (date, selectedDates, pickersDayProps) {
        if (!value) {
            return React.createElement(PickersDay_1.PickersDay, __assign({}, pickersDayProps));
        }
        var start = (0, date_fns_1.startOfWeek)(value);
        var end = (0, date_fns_1.endOfWeek)(value);
        var dayIsBetween = isBetween(date, start, end);
        var isFirstDay = (0, date_fns_1.isSameDay)(start, date);
        var isLastDay = (0, date_fns_1.isSameDay)(end, date);
        return (React.createElement(CustomPickersDay, __assign({}, pickersDayProps, { disableMargin: true, dayIsBetween: dayIsBetween, isFirstDay: isFirstDay, isLastDay: isLastDay })));
    };
};
exports.customWeekPicker = customWeekPicker;
